import { createReducer } from '@reduxjs/toolkit';
import {
  ADD_EVENT,
  DELETE_EVENT,
  DELETE_EVENT_IMAGE,
  EDIT_EVENT,
  GET_EVENT,
  GET_EVENTS,
  UPLOAD_EVENT_IMAGE
} from '../constants';
import { requestFail, requestPending, requestSuccess } from '../../utils/status';

const parseEventsPayload = (payload) => {
  if (Array.isArray(payload?.data)) {
    return payload.data;
  }

  if (Array.isArray(payload)) {
    return payload;
  }

  return [];
};

const parseEventPayload = (payload) => {
  if (!payload) {
    return null;
  }

  if (payload.data && !Array.isArray(payload.data)) {
    return payload.data;
  }

  return payload;
};

const parseEventsPagination = (payload) => {
  const headerPagination = payload?.pagination;
  if (headerPagination?.['pagination-total']) {
    const perPage = Number(headerPagination['pagination-per-page']) || 20;
    const total = Number(headerPagination['pagination-total']) || 0;

    return {
      currentPage: Number(headerPagination['pagination-current-page']) || 1,
      perPage,
      total,
      totalPages: perPage > 0 ? Math.max(1, Math.ceil(total / perPage)) : 1
    };
  }

  return {
    currentPage: 1,
    perPage: 20,
    total: 0,
    totalPages: 1
  };
};

const initialState = {
  events: [],
  event: null,
  pagination: {
    currentPage: 1,
    perPage: 20,
    total: 0,
    totalPages: 1
  },
  lastListParams: null,
  getEventsStatus: '',
  getEventStatus: '',
  addEventStatus: '',
  editEventStatus: '',
  deleteEventStatus: '',
  uploadEventImageStatus: '',
  deleteEventImageStatus: ''
};

export default createReducer(initialState, {
  [GET_EVENTS]: (state, { payload }) => ({
    ...state,
    lastListParams: payload?.params ?? state.lastListParams
  }),

  [requestSuccess(GET_EVENTS)]: (state, { payload }) => ({
    ...state,
    getEventsStatus: requestSuccess(GET_EVENTS),
    events: parseEventsPayload(payload),
    pagination: parseEventsPagination(payload)
  }),

  [requestPending(GET_EVENTS)]: (state) => ({
    ...state,
    getEventsStatus: requestPending(GET_EVENTS)
  }),

  [requestFail(GET_EVENTS)]: (state) => ({
    ...state,
    getEventsStatus: requestFail(GET_EVENTS),
    events: [],
    pagination: initialState.pagination
  }),

  [requestSuccess(GET_EVENT)]: (state, { payload }) => ({
    ...state,
    getEventStatus: requestSuccess(GET_EVENT),
    event: parseEventPayload(payload)
  }),

  [requestPending(GET_EVENT)]: (state) => ({
    ...state,
    getEventStatus: requestPending(GET_EVENT)
  }),

  [requestFail(GET_EVENT)]: (state) => ({
    ...state,
    getEventStatus: requestFail(GET_EVENT),
    event: null
  }),

  [requestSuccess(ADD_EVENT)]: (state) => ({
    ...state,
    addEventStatus: requestSuccess(ADD_EVENT)
  }),

  [requestPending(ADD_EVENT)]: (state) => ({
    ...state,
    addEventStatus: requestPending(ADD_EVENT)
  }),

  [requestFail(ADD_EVENT)]: (state) => ({
    ...state,
    addEventStatus: requestFail(ADD_EVENT)
  }),

  [requestSuccess(EDIT_EVENT)]: (state) => ({
    ...state,
    editEventStatus: requestSuccess(EDIT_EVENT)
  }),

  [requestPending(EDIT_EVENT)]: (state) => ({
    ...state,
    editEventStatus: requestPending(EDIT_EVENT)
  }),

  [requestFail(EDIT_EVENT)]: (state) => ({
    ...state,
    editEventStatus: requestFail(EDIT_EVENT)
  }),

  [requestSuccess(DELETE_EVENT)]: (state) => ({
    ...state,
    deleteEventStatus: requestSuccess(DELETE_EVENT)
  }),

  [requestPending(DELETE_EVENT)]: (state) => ({
    ...state,
    deleteEventStatus: requestPending(DELETE_EVENT)
  }),

  [requestFail(DELETE_EVENT)]: (state) => ({
    ...state,
    deleteEventStatus: requestFail(DELETE_EVENT)
  }),

  [requestSuccess(UPLOAD_EVENT_IMAGE)]: (state) => ({
    ...state,
    uploadEventImageStatus: requestSuccess(UPLOAD_EVENT_IMAGE)
  }),

  [requestPending(UPLOAD_EVENT_IMAGE)]: (state) => ({
    ...state,
    uploadEventImageStatus: requestPending(UPLOAD_EVENT_IMAGE)
  }),

  [requestFail(UPLOAD_EVENT_IMAGE)]: (state) => ({
    ...state,
    uploadEventImageStatus: requestFail(UPLOAD_EVENT_IMAGE)
  }),

  [requestSuccess(DELETE_EVENT_IMAGE)]: (state) => ({
    ...state,
    deleteEventImageStatus: requestSuccess(DELETE_EVENT_IMAGE)
  }),

  [requestPending(DELETE_EVENT_IMAGE)]: (state) => ({
    ...state,
    deleteEventImageStatus: requestPending(DELETE_EVENT_IMAGE)
  }),

  [requestFail(DELETE_EVENT_IMAGE)]: (state) => ({
    ...state,
    deleteEventImageStatus: requestFail(DELETE_EVENT_IMAGE)
  })
});
